export enum PatientPauseStatusType {
  PAUSE_DEVICE = 'PAUSE_DEVICE',
  PAUSE_QUESTIONNAIRE = 'PAUSE_QUESTIONNAIRE',
}
